if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

			constructor(){
					super();
					this.onCartSubmit = this.onCartSubmit.bind(this);
					this.onBillingFieldChange = this.onBillingFieldChange.bind(this);
					this.onBillingToggleChange = this.onBillingToggleChange.bind(this);
					this.saveBillingAttributes = debounce(this.saveBillingAttributes.bind(this), 300);
					this.ajaxifyCartItems();
				}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');
			this.setupCheckoutValidation();

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

			setupCheckoutValidation(){

				if ( ! this.form ) {
					return;
				}

				this.form.removeEventListener('submit', this.onCartSubmit);
				this.form.removeEventListener('input', this.onBillingFieldChange);
				this.form.removeEventListener('change', this.onBillingFieldChange);
				this.form.removeEventListener('change', this.onBillingToggleChange);
				this.form.addEventListener('submit', this.onCartSubmit);
				this.form.addEventListener('input', this.onBillingFieldChange);
				this.form.addEventListener('change', this.onBillingFieldChange);
				this.form.addEventListener('change', this.onBillingToggleChange);
				this.syncBillingFieldsVisibility();

			}

		onCartSubmit(event){

			if ( event.submitter?.name !== 'checkout' ) {
				return;
			}

			if ( ! this.validateBillingFields() ) {
				event.preventDefault();
			}

		}

			onBillingFieldChange(event){

				const fieldWrapper = event.target.closest('[data-cart-billing-field]');
				if ( ! fieldWrapper ) {
					return;
			}

			this.clearBillingError(fieldWrapper.dataset.cartBillingField);
			this.saveBillingAttributes();

			}

				onBillingToggleChange(event){

					if ( ! event.target.matches('[data-cart-billing-toggle]') ) {
						return;
					}

					this.syncBillingFieldsVisibility();
					this.saveBillingAttributes();

				}

			syncBillingFieldsVisibility(){

				const billingToggle = this.form.querySelector('[data-cart-billing-toggle]');
				const billingFieldsContent = this.form.querySelector('[data-cart-billing-fields-content]');

				if ( ! billingToggle || ! billingFieldsContent ) {
					return;
				}

				const isEnabled = billingToggle.checked;
				billingFieldsContent.hidden = ! isEnabled;

				this.form.querySelectorAll('[data-cart-billing-required="true"]').forEach(field => {
					field.required = isEnabled;
				});

				if ( ! isEnabled ) {
					['RFC', 'Razon Social', 'Uso CFDI'].forEach(fieldName => {
						this.clearBillingError(fieldName);
					});
				}

			}

			saveBillingAttributes(){

					if ( ! this.form ) {
						return;
					}

					const billingToggle = this.form.querySelector('[data-cart-billing-toggle]');
					const rfc = this.form.querySelector('[name="attributes[RFC]"]');
					const razonSocial = this.form.querySelector('[name="attributes[Razon Social]"]');
					const usoCfdi = this.form.querySelector('[name="attributes[Uso CFDI]"]');

					if ( ! rfc || ! razonSocial || ! usoCfdi ) {
				return;
			}

					const body = JSON.stringify({
						attributes: {
							'RFC': billingToggle && ! billingToggle.checked ? '' : rfc.value.trim(),
							'Razon Social': billingToggle && ! billingToggle.checked ? '' : razonSocial.value.trim(),
							'Uso CFDI': billingToggle && ! billingToggle.checked ? '' : usoCfdi.value.trim()
						}
					});

			fetch(KROWN.settings.routes.cart_update_url, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
				body
			}).catch(e => {
				console.log(e);
			});

		}

			validateBillingFields(){

				const billingToggle = this.form.querySelector('[data-cart-billing-toggle]');
				if ( billingToggle && ! billingToggle.checked ) {
					['RFC', 'Razon Social', 'Uso CFDI'].forEach(fieldName => {
						this.clearBillingError(fieldName);
					});
					return true;
				}

				const fields = {
					'RFC': this.form.querySelector('[name="attributes[RFC]"]'),
				'Razon Social': this.form.querySelector('[name="attributes[Razon Social]"]'),
				'Uso CFDI': this.form.querySelector('[name="attributes[Uso CFDI]"]')
			};
			const rfcPattern = /^[A-Z&Ñ]{3,4}\d{6}[A-Z0-9]{3}$/i;
			let isValid = true;

			Object.keys(fields).forEach(fieldName => {
				const field = fields[fieldName];
				if ( ! field ) {
					return;
				}

				const value = field.value.trim();
				this.clearBillingError(fieldName);

				if ( value === '' ) {
					this.setBillingError(fieldName, 'Este campo es obligatorio.');
					isValid = false;
					return;
				}

				if ( fieldName === 'RFC' && ! rfcPattern.test(value) ) {
					this.setBillingError(fieldName, 'Ingresa un RFC valido.');
					isValid = false;
				}
			});

			if ( ! isValid ) {
				const firstInvalidField = this.form.querySelector('[data-cart-billing-field-error="true"] input, [data-cart-billing-field-error="true"] select');
				firstInvalidField?.focus();
			}

			return isValid;

		}

		setBillingError(fieldName, message){

			const fieldWrapper = this.form.querySelector(`[data-cart-billing-field="${fieldName}"]`);
			const error = this.form.querySelector(`[data-cart-billing-error-for="${fieldName}"]`);
			const field = this.form.querySelector(`[name="attributes[${fieldName}]"]`);

			if ( fieldWrapper ) {
				fieldWrapper.dataset.cartBillingFieldError = 'true';
			}
			if ( field ) {
				field.setAttribute('aria-invalid', 'true');
			}
			if ( error ) {
				error.textContent = message;
				error.hidden = false;
			}

		}

		clearBillingError(fieldName){

			const fieldWrapper = this.form.querySelector(`[data-cart-billing-field="${fieldName}"]`);
			const error = this.form.querySelector(`[data-cart-billing-error-for="${fieldName}"]`);
			const field = this.form.querySelector(`[name="attributes[${fieldName}]"]`);

			if ( fieldWrapper ) {
				fieldWrapper.removeAttribute('data-cart-billing-field-error');
			}
			if ( field ) {
				field.removeAttribute('aria-invalid');
			}
			if ( error ) {
				error.textContent = '';
				error.hidden = true;
			}

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						});
		  		}, 150)
				);
      }
    }
  );
}
